import { Add } from "@/components/Icons";
import classes from "./AddDegreeButton.module.css";
import Text from "@/components/Text";
import Button from "@/components/Button";
import { useTranslation } from "@/i18n/client";

interface AddDegreeButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

const AddDegreeButton = ({ onClick, disabled }: AddDegreeButtonProps) => {
  const { t } = useTranslation("customer");
  return (
    <Button unstyled className={classes.button} onClick={onClick} disabled={disabled}>
      <Add fontSize={24} />
      <Text variant="reading_medium_bold">{t("addDegree")}</Text>
    </Button>
  );
};

export default AddDegreeButton;
